import { Component, OnInit, OnDestroy, ApplicationRef, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, first, takeUntil } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { getSchoolFromUrl } from './utils/utils';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'viresco-edu-web';
  isIframe = false;
  loginDisplay = false;

  private readonly _destroying$ = new Subject<void>();
  private authService = inject(MsalService);
  private appRef = inject(ApplicationRef);
  private router = inject(Router);
  private msalBroadcastService = inject(MsalBroadcastService);

  private readonly envConfig = {
    localhost: 'https://login.localhost:4200',
    homologacao: 'https://login.portalpaishomologacao.virescoerp.com.br',
    producao: 'https://login.portalpais.virescoerp.com.br',
  };

//   ngOnInit(): void {
//   this.isIframe = window !== window.parent && !window.opener;
//   console.log('aaaaaa');


//   this.appRef.isStable.pipe().subscribe(() => {
//     // this.handleAuthenticationFlow();
//   })

//   this.appRef.isStable.pipe().subscribe(() => {

//     this.authService.instance.handleRedirectPromise().then((result) => {
//       this.setLoginDisplay();
//       // se usuario nao autenticado e nao for iframe
//       if(!this.loginDisplay && !result && !this.isIframe) {
//         this.autenticaUsuario(result);
//       }

//       if (result && result.account) {
//         const returnUrl = decodeURIComponent(result.state || '');

//         if (returnUrl && returnUrl !== window.location.origin) {
//           // 🔁 Redireciona para o subdomínio original
//           window.location.href = `${returnUrl}/home`;
//         }
//       }

//     }).catch((error) => {
//         console.error('❌ Erro no handleRedirectPromise:', error);
//         this.setLoginDisplay();
//     });
//     this.msalBroadcastService.inProgress$
//     .pipe(
//       filter((status) => status === InteractionStatus.None),
//       takeUntil(this._destroying$)
//     )
//     .subscribe(() => {
//       this.setLoginDisplay();
//       this.checkAndSetActiveAccount();
//     });

//   });

// }

//   ngOnDestroy(): void {
//     this._destroying$.next();
//     this._destroying$.complete();
//   }

//   private setLoginDisplay(): void {
//     this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
//   }

//   private checkAndSetActiveAccount(): void {
//     const current = this.authService.instance.getActiveAccount();
//     const allAccounts = this.authService.instance.getAllAccounts();

//     if (!current && allAccounts.length > 0) {
//       this.authService.instance.setActiveAccount(allAccounts[0]);
//     }
//   }

//   private redirectToCentralizedLogin(): void {
//     const currentHost = window.location.hostname;

//     if (currentHost.startsWith('login.')) {
//       return; // Já está no login centralizado, não redireciona
//     }

//     const currentOrigin = window.location.origin;
//     // const redirectParam = encodeURIComponent(currentOrigin);
//     const redirectParam = encodeURIComponent(currentOrigin);

//     let loginDomain = environment.loginUrl;

//     const loginUrl = `${loginDomain}/?returnUrl=${redirectParam}`
//     console.log('🔐 Redirecionando para login centralizado:', loginUrl);
//     window.location.href = loginUrl;

//   }

//   autenticaUsuario(result: any) {
//     const urlParams = new URLSearchParams(window.location.search);
//     // this.appRef.isStable.pipe(first()).subscribe(() => {
//     // this.authService.instance.handleRedirectPromise().then((result) => {
//       this.setLoginDisplay();
//       this.checkAndSetActiveAccount();

//       let redirectParam = urlParams.get('returnUrl');
//       if (redirectParam) {
//         localStorage.setItem('returnUrl', redirectParam);
//       }

//       if(!result && !this.loginDisplay && !this.isIframe && redirectParam){
//         console.log('uma vez')
//           this.authService.loginRedirect({
//           scopes: ['openid', 'profile', 'https://saguitechb2c.onmicrosoft.com/8be9481b-b76f-457d-aaba-84fc7a4cd91a/PortalPais.Read'],
//           // extraQueryParameters: {
//           //   returnUrl: encodeURIComponent(redirectParam)
//           // },
//           state: encodeURIComponent(redirectParam)
//         });
//       }

//       // if (result && result.account) {
//       //     const returnUrl = decodeURIComponent(result.state || '');

//       //     if (returnUrl && returnUrl !== window.location.origin) {
//       //       // 🔁 Redireciona para o subdomínio original
//       //       window.location.href = `${returnUrl}/home`;
//       //     }
//       //   }

//       // Aguarda o status do MSAL estar "estável"
//       // setTimeout(() => {
//         const host = window.location.hostname;
//         const isLoginDomain = host.startsWith('login.');
//         console.log(host);

//         if (!this.loginDisplay && !this.isIframe && !isLoginDomain) {
//           console.log('🔐 Redirecionando para login centralizado');
//           this.redirectToCentralizedLogin();
//         }
//       // }, 300); // pequeno delay para MSAL finalizar o estado

//   //   }).catch((error) => {
//   //     console.error('❌ Erro no handleRedirectPromise:', error);
//   //     this.setLoginDisplay();
//   //   });
//   // });

//   // Atualizar status de login quando o estado mudar
//   this.msalBroadcastService.inProgress$
//     .pipe(
//       filter((status) => status === InteractionStatus.None),
//       takeUntil(this._destroying$)
//     )
//     .subscribe(() => {
//       this.setLoginDisplay();
//       this.checkAndSetActiveAccount();
//     });
//   }

//   // private handleAuthenticationFlow() {
//   //   try{

//   //     this.authService.instance.handleRedirectPromise().then((result) => {
//   //       if(result && result.account && !window.location.hostname.startsWith('login.')) {
//   //         console.log('🔐 Autenticação bem-sucedida:', result.account)
//   //         return; // já autenticado, não precisa redirecionar

//   //       };
//   //       this.setLoginDisplay();
//   //       this.checkAndSetActiveAccount();

//   //       if (!result && !this.loginDisplay && !this.isIframe) {
//   //         if(!window.location.hostname.startsWith('login.')){
//   //           console.log('🔐 Redirecionando para login centralizado');
//   //           this.redirectToCentralizedLogin();
//   //           return;
//   //         }

//   //         const urlParams = new URLSearchParams(window.location.search);
//   //         const redirectParam = urlParams.get('returnUrl');
//   //         if (redirectParam) {
//   //           localStorage.setItem('returnUrl', redirectParam);
//   //           this.authService.loginRedirect({
//   //             scopes: ['openid', 'profile', 'https://saguitechb2c.onmicrosoft.com/8be9481b-b76f-457d-aaba-84fc7a4cd91a/PortalPais.Read'],
//   //             // state: encodeURIComponent(redirectParam),
//   //           });
//   //         }
//   //       }

//   //       // Se retornou do Azure AD com sucesso
//   //       if (result && result.account) {
//   //         const returnUrl = localStorage.getItem('returnUrl') || '';
//   //         console.log('Login bem-sucedido, returnUrl:', returnUrl);

//   //         if (returnUrl && returnUrl !== window.location.origin) {
//   //           // Redireciona para o subdomínio original
//   //           const finalRedirect = `${returnUrl}/home`;
//   //           console.log('Redirecionando para subdomínio original:', finalRedirect);
//   //           window.location.href = finalRedirect;
//   //           return;
//   //         }
//   //       }
//   //     });

//   //   } catch (error) {
//   //     console.error('❌ Erro no handleAuthenticationFlow:', error);
//   //   }
//   // }

ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    this.appRef.isStable.pipe(first()).subscribe(() => {
      this.authService.instance.handleRedirectPromise()
        .then((result) => {
          if (result && result.account) {
            this.authService.instance.setActiveAccount(result.account);
            // let prefixUrl = localStorage.getItem('school');
            // console.log(prefixUrl)
            // this.router.navigate([prefixUrl, 'home']);
          }

          // const returnUrl = sessionStorage.getItem('returnUrl');
          // if (returnUrl) {
          //   sessionStorage.removeItem('returnUrl');
          //   window.location.href = returnUrl;
          // } else {
          //   // fallback: manda pra /<escola>/home
          //   // window.location.href = '/default/home';
          //   // this.router.navigate(['/default/home']);
          // }

          this.setLoginDisplay();
          this.checkAndSetActiveAccount();
          if(!this.loginDisplay && !this.isIframe) {
            let prefix = getSchoolFromUrl() ?? '';
            console.log(prefix);
            // const returnUrl = window.location.pathname;
            sessionStorage.setItem('school', prefix);

            this.login();
          }

        })
        .catch((error) => {
          console.error('❌ Erro no handleRedirectPromise:', error);
        });


      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status) => status === InteractionStatus.None),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
          this.setLoginDisplay();
          this.checkAndSetActiveAccount();
        });
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  private setLoginDisplay(): void {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  private checkAndSetActiveAccount(): void {
    const current = this.authService.instance.getActiveAccount();
    const allAccounts = this.authService.instance.getAllAccounts();
    if (!current && allAccounts.length > 0) {
      this.authService.instance.setActiveAccount(allAccounts[0]);
    }
  }

  private login(): void {
    const loginRequest: RedirectRequest = {
      scopes: [
        'openid',
        'profile',
        'https://saguitechb2c.onmicrosoft.com/8be9481b-b76f-457d-aaba-84fc7a4cd91a/PortalPais.Read'
      ]
    };

    this.authService.loginRedirect(loginRequest);
  }

}
